module.exports = __webpack_public_path__ + "static/media/crown-white.43964864.svg";